export const convertPerQuestionDiagramToTotal = perQuestionDiagram => {
    if (!perQuestionDiagram) {
        return
    }

    const questionsValues = Object.values(perQuestionDiagram)

    if (questionsValues.every(v => v.total == -1)) {
        return {
            total: -1,
            left: -1,
        }
    }

    return {
        total: questionsValues.map(v => v.total).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
        left: questionsValues.map(v => v.left).reduce((accumulator, currentValue) => accumulator + currentValue, 0),
    }
}

export const convertPerQuestionDiagramToTotalCount = perQuestionDiagram => {
    if (!perQuestionDiagram) {
        return
    }

    const questionsValues = Object.values(perQuestionDiagram)

    return {
        total: questionsValues.length,
        left: questionsValues.filter(x => Boolean(x.left)).length,
    }
}

export const convertBooleanMapToTotal = perQuestionBooleanMap => {
    if (!perQuestionBooleanMap) {
        return
    }

    const questionsValues = Object.values(perQuestionBooleanMap)

    return {
        total: questionsValues.length,
        left: questionsValues.filter(x => !x).length,
    }
}

export const convertPerQuestionNestedBooleanMapToPerQuestion = nestedPerQuestionBooleanMap => {
    if (!nestedPerQuestionBooleanMap) {
        return
    }

    const result = {}

    Object.keys(nestedPerQuestionBooleanMap).forEach(key => {
        const perQuestionBooleanMap = nestedPerQuestionBooleanMap[key]

        result[key] = convertBooleanMapToTotal(Object.values(perQuestionBooleanMap))
    })

    return result
}
